module.exports = __webpack_public_path__ + "static/wakefield-free-bus-sm-1647cfb9d43fc11e762f065bd21e6f69.webp";